import moment from 'moment';
import { fewDayAgo } from '../utils/date';

export const getDateFormat = (l) =>
  ({
    chs: 'YYYY-MM-DD',
    en: 'D/M/YYYY',
    fr: 'D/M/YYYY',
    it: 'D/M/YYYY',
    tr: 'D/M/YYYY',
  }[l]);
export const dateFormat = 'YYYY-MM-DD';
export const timeFormat = `${dateFormat} HH:mm`;
export const getTimeFormat = (l, suffix='') => `${getDateFormat(l)} ${suffix}`;
export const presetDateRange = {
  today: [moment(), moment()],
  yesterday: [moment(fewDayAgo(1)), moment(fewDayAgo(1))],
  this_month: [moment().startOf('month'), moment().endOf('month')],
  near_day30: [moment(fewDayAgo(30)), moment()],
};

export const shopFilter = { name: 'shop', code: 'shop_id' };

export const goodFilters = {
  statusFilters: [
    {
      name: 'dead_status',
      code: 'disable',
      options: [
        { name: 'open', value: '0' },
        { name: 'dead', value: '1' },
      ],
    },
  ],
  cusFilters: [
    {
      name: 'custom_condition',
      code: 'orders',
      options: [
        { name: 'zero_price_in', value: 'zero_price_in' },
        { name: 'zero_price_1', value: 'zero_price_1' },
      ],
    },
  ],
};

export const customerFilter = [
  {
    name: 'client_vip',
    code: 'vip',
    options: [
      { name: 'A,Client', value: '1' },
      { name: 'B,Client', value: '2' },
      { name: 'C,Client', value: '3' },
      { name: 'D,Client', value: '4' },
    ],
  },
];

export const billFilter = [
  ...customerFilter,
  {
    name: 'order_status',
    code: 'edit_status',
    options: [
      { name: 're_modify', value: '1' },
      { name: 'un_modify', value: '0' },
    ],
  },
  {
    name: 'pay_status',
    code: 'pay_status',
    options: [
      // { name: '未付款', value: '0' },
      // { name: '部分付款', value: '1' },
      // { name: '全部付款', value: '2' },
      { name: 'un_pay', value: '1' },
      { name: 'part_pay', value: '2' },
      { name: 'all_pay', value: '3' },
    ],
  },
  {
    name: 'shipping_status',
    code: 'shipping_status',
    options: [
      { name: 'un_shipping', value: '1' },
      { name: 'part_shipping', value: '2' },
      { name: 'all_shipping', value: '3' },
    ],
  },
];

export const financeFilter = [
  {
    name: 'type',
    code: 'pay_channel',
    options: [
      { name: 'batch_pay', value: 'batch_pay' },
      { name: 'order_pay', value: 'order_pay' },
    ],
  },
  {
    name: 'channel',
    code: 'pay_type',
    options: [
      { name: 'Client', value: 'client' },
      { name: 'supplier_', value: 'supplier' },
      { name: 'daily_pay', value: 'daily' },
    ],
  },
  {
    name: 'budget',
    code: 'pay_direction',
    options: [
      { name: 'income', value: 'in' },
      { name: 'expend', value: 'out' },
    ],
  },
];

export const filterAliasMap = { category: 'goods_category' };

export const goodBatch = {
  del: 'del',
  disable: 'disable',
  classic: 'classic',
  brand: 'brand',
  season: 'season',
  year: 'year',
  replenishmentAdd: 'replenishment-added',
  replenishmentReduce: 'replenishment-reduce',
};

export const relativeBatch = {
  attr: 'attr',
  del: 'del',
};

// 分页基础配置
export const pageConfig = {
  pageSizeOptions: ['10', '30', '50', '80', '100', '200'],
};
